// extracted by mini-css-extract-plugin
export default {"DeleteContentTagDialog":"DeleteContentTagDialog_DeleteContentTagDialog__mwapi"};